import { Datepicker } from 'vanillajs-datepicker';
import fi from 'vanillajs-datepicker/locales/fi';
Object.assign(Datepicker.locales, fi);

$(document).ready(function()
{
  if ($("#frmProfile").length > 0)
  {
    $(".date").each(function()
    {
      let $txt = $(this);

      const datepicker = new Datepicker($txt.get(0), {
        buttonClass: "btn",
        language: LANG
      });
    });
  }
});
